import styled from '@emotion/styled';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import theme from '@ep/theme';
import { NavItem } from '@ep/types/menuData';
import React from 'react';
import SubNavItemLabel from '../SubNavItemLabel';
import SubmenuLink from './SubmenuLink';

export interface SubmenuProps {
  navItem: NavItem;
  subMenuState: string | undefined;
}

const Wrapper = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  padding: 2rem 0 0;
  text-align: center;
`;

interface SubmenuContainerProps {
  hasSideMenu: boolean;
}

const SubmenuContainer = styled.div<SubmenuContainerProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0 ${({ hasSideMenu }) => (hasSideMenu ? 0 : 'auto')} 0 auto;
  max-width: ${({ hasSideMenu }) => (hasSideMenu ? '34rem' : '1110px')};
`;

const StyledSubNavItemLabel = styled(SubNavItemLabel)`
  margin: 1.5rem 1rem 0;
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  text-align: left;
  margin: 0 0 1rem 1rem;
`;

interface GridProps {
  columnCount: number;
}

const Grid = styled.div<GridProps>`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(${({ columnCount }) => columnCount}, 1fr);
  grid-auto-rows: 12rem;
  margin: 0 auto;
  max-width: ${theme.breakpoints.desktop}px;
`;

function GetSubmenu(navItem: NavItem, subMenuState: string) {
  var submenuItems;
  if (subMenuState === 'default') {
    submenuItems = navItem.submenu;
  } else {
    var navIndex = navItem.sidemenu.findIndex(function(item, i) {
      if (item.label == subMenuState) {
        return i;
      }
    });
    submenuItems = navItem.sidemenu[navIndex != -1 ? navIndex : 0].links;
  }

  return submenuItems;
}

function Submenu({ navItem, subMenuState }: SubmenuProps) {
  var submenuItems = GetSubmenu(navItem, subMenuState);

  return (
    <Wrapper>
      <SubmenuContainer hasSideMenu={Boolean(navItem.sidemenu)}>
        <Grid columnCount={navItem.sidemenu ? 3 : 6}>
          {submenuItems?.map(subNavItem => (
            <SubmenuLink key={subNavItem.label} subNavItem={subNavItem} />
          ))}
        </Grid>
        {navItem.cta && (
          <StyledSeeMoreLink label={navItem.cta} to={navItem.link ?? '/'} />
        )}
      </SubmenuContainer>
    </Wrapper>
  );
}

export default React.memo(Submenu);
